export enum ProductSelectMode {
    Any = 0,
    Type = 1,
    Select = 2,
}

export enum EarlyBirdAccommodationType {
    Homestay = 1,
    Residence = 2,
}

export enum EarlyBirdAddOnType {
    OneToOneCourse = 1,
    Exam = 2,
    Activity = 3,
    Insurance = 4
}

export enum StudyDateRangeMode {
    Covers = 0,
    Within = 1,
    Intersect = 2,
}

export interface EarlyBirdOfferItemDto {
    year: number;
    lastModifiedBy: string;
    updateTimestamp: string;
    active: boolean;
}

export interface EarlyBirdOfferDto {
    rules: EarlyBirdRuleDto[];
}

export interface EarlyBirdRuleDto {
    name: string;
    earlyBirdEndDate: string;
    include: EarlyBirdConditionDto[];
    exclude: EarlyBirdConditionDto[];
}

export interface DateRangeDto {
    from?: string;
    to?: string;
}

export interface AgentNodeDto {
    agentId?: string;
    agentOfficeIds?: string[];
}

export type EarlyBirdConditionDto =
    | EarlyBirdConditionAdmissionRegion
    | EarlyBirdConditionAgent
    | EarlyBirdConditionAge
    | EarlyBirdConditionArrivalDepartureDates
    | EarlyBirdConditionBookingSystem
    | EarlyBirdConditionCourse
    | EarlyBirdConditionAccommodation
    | EarlyBirdConditionAddOn
    | EarlyBirdConditionTransfer
    | EarlyBirdConditionSaleCountry
    | EarlyBirdConditionSchool
    | EarlyBirdConditionStudyStartEndDates;

export interface EarlyBirdConditionAdmissionRegion {
    field: 'admissionRegion';
    region?: string;
}

export interface EarlyBirdConditionAgent {
    field: 'agent';
    agents?: AgentNodeDto[];
}

export interface EarlyBirdConditionAge {
    field: 'age';
    minAge?: number;
    maxAge?: number;
    dateOfBirth?: string;
}

export interface EarlyBirdConditionArrivalDepartureDates {
    field: 'arrivalDepartureDates';
    arrival?: DateRangeDto;
    departure?: DateRangeDto;
}

export interface EarlyBirdConditionBookingSystem {
    field: 'bookingSystem';
    bookingSystemId?: string;
}

export interface EarlyBirdConditionCourse {
    field: 'course';
    mode: ProductSelectMode;
    courseIds?: string[];
    minWeeks?: number;
    maxWeeks?: number;
}

export interface EarlyBirdConditionAccommodation {
    field: 'accommodation';
    mode: ProductSelectMode;
    kind?: EarlyBirdAccommodationType;
    accommodationIds?: string[];
    minWeeks?: number;
    maxWeeks?: number;
}

export interface EarlyBirdConditionAddOn {
    field: 'addOn';
    mode: ProductSelectMode;
    kind?: EarlyBirdAddOnType;
    addOnIds?: string[];
}

export interface EarlyBirdConditionTransfer {
    field: 'transfer';
    mode: ProductSelectMode;
    transferIds?: string[];
}

export interface EarlyBirdConditionSaleCountry {
    field: 'saleCountry';
    countryCodes?: string[];
}

export interface EarlyBirdConditionSchool {
    field: 'school';
    schoolIds?: string[];
}

export interface EarlyBirdConditionStudyStartEndDates {
    field: 'studyStartEndDates';
    studyStartEnd?: DateRangeDto;
    mode: StudyDateRangeMode;
}